<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">개인회원 정보</h5>
        <v-divider class="primary border-2" />
        <v-data-table
            v-bind="{
                headers,

                items,
                itemKey: '_id',
                itemsPerPage: -1,

                loading,
            }"
            hide-default-footer
            disable-filtering
            disable-sort
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

            <template #[`item.info.name`]="{ item, value }">
                <v-layout column align-center>
                    <span class="mb-4 mb-lg-8"> {{ value }} </span>
                    <expo-employee-view
                        v-bind="{
                            _employee: item._id,
                            _program,
                        }"
                    >
                        <template #activator="{ attrs, on }">
                            <v-btn small outlined width="100" color="grey-d" v-bind="attrs" v-on="on">
                                <span class="grey--text"> 지원정보 </span>
                            </v-btn>
                        </template>
                    </expo-employee-view>
                </v-layout>
            </template>

            <template #[`item.grant`]="{ item }">
                <employees-item-grant
                    v-bind="{
                        value: item,
                        program,
                        isUserHost,
                    }"
                    @input="updateItem"
                />
            </template>

            <template #[`item.match`]="{ item }">
                <employees-item-match
                    v-bind="{
                        program,
                        employee: item,
                        isUserHost,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                />
            </template>

            <template #footer>
                <v-divider />
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="my-8" />
            </template>
        </v-data-table>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { mapActions, mapGetters, mapState } from "vuex";
import { initExpoEmployee } from "@/assets/variables";

import EmployeesItemGrant from "./employees/employees-item-grant.vue";
import EmployeesItemMatch from "./employees/employees-item-match.vue";
import ExpoEmployeeView from "@/components/client/expo/employee/expo-employee-view.vue";

export default {
    components: {
        EmployeesItemGrant,
        EmployeesItemMatch,
        ExpoEmployeeView,
    },
    props: {
        isTabActive: { type: Boolean, default: false },
    },
    data: () => ({
        employees: [],
        summary: { totalCount: 0 },

        limit: 10,
        page: 1,

        loading: false,
    }),
    computed: {
        ...mapState("expo", ["program"]),
        ...mapGetters("expo", ["_program", "isUserHost", "isUserEmployee", "isUserEmployer"]),
        ...mapGetters(["doesUserHaveConsoleScope"]),

        headers() {
            let headers = [
                { text: "지원자명", value: "info.name", width: 180 },
                { text: "연락처", value: "info.phone", width: 140, cellClass: "word-break-break-all" },
                { text: "이메일", value: "info.email", width: 140, cellClass: "word-break-break-all" },
                { text: "소개", value: "info.desc", cellClass: "text-start white-space-pre-line" },
            ];

            if (this.isUserHost || this.doesUserHaveConsoleScope) {
                headers.push({ text: "상태", value: "grant", width: 140 });
            }

            if (this.isUserEmployer) {
                headers.push({ text: "면접요청", value: "match", width: 140 });
            }

            return headers.map((item) => ({
                ...item,
                align: item.align ?? "center",
                cellClass: (item.cellClass || "") + " px-10 px-lg-20 py-8 py-lg-16",
            }));
        },
        items() {
            return this.employees.map(initExpoEmployee);
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    methods: {
        ...mapActions("expo", ["getMatchings"]),
        ...mapActions("expo", { expoInit: "init" }),

        init() {
            this.search();
        },
        async search() {
            if (!this.isTabActive) return;

            this.loading = true;
            try {
                let { _program, skip, limit } = this;
                let { summary, employees } = await api.v1.expo.programs.employees.gets({
                    _program,
                    headers: { skip, limit },
                });
                this.employees = employees;
                this.summary = summary;

                if (this.isUserEmployer) this.getMatchings();
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            this.loading = true;
            try {
                item._program = this._program;
                let { employee } = await api.v1.expo.programs.employees.put(item);

                this.loading = false;

                employee = initExpoEmployee(employee);
                this.updateItem(employee);
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        updateItem(employee) {
            const index = this.employees.findIndex(({ _id }) => _id == employee._id);
            if (0 <= index) this.employees.splice(index, 1, employee);
            else {
                this.employees = [employee, ...this.employees];
                this.summary.totalCount += 1;
            }
            this.employees = [...this.employees];

            this.search();
            this.expoInit();
        },
    },
    watch: {
        isTabActive() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
::v-deep .word-break-break-all {
    word-break: break-all;
}
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>